import { Reducer } from 'redux';
import { SolicitacoesRetornoState, SolicitacoesRetornoTypes } from './types';

const INITIAL_STATE: SolicitacoesRetornoState = {
  data: [],
  error: false,
  loading: false,
  notas: [],
  filter: undefined,
  sorter: undefined,
  pagination: {
    total: 0,
    pageSize: 5,
    current: 1,
    showSizeChanger: true,
    pageSizeOptions: ['5', '10', '20', '50'],
  },
};

const reducer: Reducer<SolicitacoesRetornoState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SolicitacoesRetornoTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SolicitacoesRetornoTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
        pagination: action.payload.pagination,
      };
    case SolicitacoesRetornoTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case SolicitacoesRetornoTypes.CLEAN_DETALHES_ITENS_NOTA:
      return {
        ...state,
        loading: false,
        error: true,
        itensNota: [],
      };
    case SolicitacoesRetornoTypes.ITENS_NOTA_SECUNDARIAS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SolicitacoesRetornoTypes.ITENS_NOTA_SECUNDARIAS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        notas: action.payload.notas,
      };
    case SolicitacoesRetornoTypes.ITENS_NOTA_SECUNDARIAS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        notas: [],
      };
    case SolicitacoesRetornoTypes.FILTER_SOLICITACOES_RETORNO:
      return {
        ...state,
        filter: action.payload.filter,
      };
    case SolicitacoesRetornoTypes.SORTER_SOLICITACOES_RETORNO:
      return {
        ...state,
        sorter: action.payload.sorter,
      };
    case SolicitacoesRetornoTypes.CLEAN_DETALHES_ITENS_NOTA_SECUNDARIAS:
      return {
        ...state,
        loading: false,
        error: true,
        notas: [],
      };
    case SolicitacoesRetornoTypes.CLEAN_MOVISAIDA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
